export const QUERY_KEYS = {
  DEPARTMENT_MEMBERS: "DEPARTMENT_MEMBERS",
};
